<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="d-flex justify-center text-center"
    style="width: 100%;"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      style="max-width: 360px"
    >
      <div
        class="text-h3 font-weight-medium mb-2"
      >
        {{ title }}
      </div>
      <div
        :class="haveError?'error--text':'text--secondary '"
        class="text-body-2 mb-2"
      >
        {{ hint + (extraHint ? ',' + extraHint : '') }}
      </div>
      <v-otp-input
        :value="buffer"
        class="mt-2 mb-2"
        length="6"
        readonly
        type="password"
      />
      <div style="width: 100%">
        <div style="display: grid;grid-template-columns: repeat(4,1fr);grid-gap: 8px">
          <v-card
            v-for="(k,o) in currentKeys"
            :key="k+o"
            :color="colors[o]||'grey lighten-4'"
            elevation="0"
            @click="input(k)"
          >
            <v-responsive
              :aspect-ratio="1"
              class="d-flex align-center text-center text-h2 font-weight-medium"
            >
              {{ k }}
            </v-responsive>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'

const key = [
  '7', '8', '9', '←',
  '4', '5', '6', '',
  '1', '2', '3', '',
  '', '0', '', 'C'
]
const checkKey = [
  '7', '8', '9', '←',
  '4', '5', '6', '',
  '1', '2', '3', '',
  '', '0', '', 'C'
]
const colors = [
  '', '', '', 'yellow lighten-4',
  '', '', '', '',
  '', '', '', '',
  '', '', '', 'error lighten-4'
]
export default {
  name: 'OTPKeyboard',
  props: {
    title: {},
    checkTwice: {},
    loading: {},
    extraHint: {}
  },
  data: function () {
    return {
      colors,
      firstTimeResult: '',
      step: 0,
      buffer: '',
      errorMessage: ''
    }
  },
  computed: {
    currentKeys () {
      return this.step === 0 ? key : checkKey
    },
    haveError () {
      return !!this.errorMessage
    },
    hint () {
      if (this.errorMessage) {
        return this.errorMessage
      } else {
        switch (this.step) {
          case 0:
            return i18n.t('PersonalSettingsPinEnter')
          case 1:
            return i18n.t('PersonalSettingsPinReEnter')
        }
        return ''
      }
    }
  },
  watch: {
    buffer (val) {
    }
  },
  mounted () {
    this.initial()
  },
  methods: {
    initial () {
      this.firstTimeResult = ''
      this.step = 0
      this.buffer = ''
      this.errorMessage = ''
    },
    input (key) {
      switch (key) {
        case 'C':
          this.buffer = ''
          break
        case '←':
          this.buffer = this.buffer.substring(0, this.buffer.length - 1)
          break
        default:
          this.buffer += key
          if (this.buffer.length > 5) {
            this.tryToSubmit()
          }
          break
      }
    },
    setErrorMessage (message) {
      this.errorMessage = message
      setTimeout(() => {
        this.errorMessage = ''
      }, 3000)
    },
    tryToSubmit () {
      if (this.checkTwice && !this.firstTimeResult) {
        this.firstTimeResult = this.buffer
        this.step = 1
      } else if (this.firstTimeResult) {
        if (this.firstTimeResult === this.buffer) {
          this.$emit('submit', this.firstTimeResult)
        } else {
          this.initial()
          this.setErrorMessage(this.$t('TwicePinsAreWrong'))
        }
      } else {
        this.$emit('submit', this.buffer)
      }
      this.buffer = ''
    }
  }
}
</script>

<style scoped>

</style>
